import { FormControl, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replaceAll } from '../../../global/helpers/string-helpers';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyCompReportSettings } from '../../arc/models/arc-epi-props';
import { handleDioClick } from '../map-actions';
import { regionMap } from '../models';


export function RegionDropdown() {

	const selectedRegion = useSelector<TcsmStates, string>(state => state?.clergyCompReportState.selectedRegion);
	const seletedDio = useSelector<TcsmStates, string>(state => state?.clergyCompReportState.selectedDio);
	const settings = useSelector<TcsmStates, ClergyCompReportSettings>(state => state?.epiProps?.clergyCompReportSettingsState?.epiContent);

	const dispatch = useDispatch();
	const handleChange = (evt) => {
		const svg = document.getElementById('domestic-svg');
		let region = null;
		let diocese = null;
		svg.childNodes.forEach(r => {
			if (r.nodeName === 'g' && (r as HTMLElement)?.getAttribute('prov') === selectedRegion) {
				region = r;
				r?.childNodes?.forEach(d => {
					if (d.nodeName === 'g' && (d as HTMLElement)?.getAttribute('id') === evt?.target?.value) {
						diocese = d;
					}
				});
			}
		});

		handleDioClick(diocese as HTMLElement, region as HTMLElement, dispatch);

	};

	return (
		<FormControl >
			<Select
				value={seletedDio}
				onChange={handleChange}
				displayEmpty
				renderValue={(selected: any) => {
					if (!selected || selected?.length === 0) {
						return <em>{settings?.domesticLabel}</em>;
					}
					const link = regionMap[selectedRegion]?.filter(a => a === replaceAll(selected?.replace('Dio_', ''), '_', ' '));
					return link[0];
				}}
			>
				{
					regionMap[selectedRegion]?.map(a => <MenuItem key={a} value={`Dio_${replaceAll(a, ' ', '_')}`}>{a}</MenuItem>)
				}

			</Select>
		</FormControl>
	);
}